import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SignatureAccesKey } from '../../interfaces/blobStorage';

const evidenceApiUrl = environment.evidenceApiUrl;

@Injectable()
export class SasProvider {

  constructor(private http: HttpClient) { }

  public async getSas(fileName: string): Promise<SignatureAccesKey> {
    const body = {
      fileName: fileName
    };
    return this.http.post<SignatureAccesKey>(evidenceApiUrl + '/' + 'generateSAS', body).toPromise();
  }
}
